export class RouteType {
    static GOING = 'GOING';
    static GOING_AND_COMING = 'GOING_AND_COMING';
}

Object.freeze(RouteType);